export * from './components/Icon/index';
